var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 10C23 13.866 19.866 17 16 17C12.134 17 9 13.866 9 10C9 6.13401 12.134 3 16 3C19.866 3 23 6.13401 23 10ZM24 10C24 14.4183 20.4183 18 16 18C15.6501 18 15.3055 17.9775 14.9675 17.934C13.5939 20.3615 10.9883 22 8 22C3.58172 22 0 18.4183 0 14C0 9.58172 3.58172 6 8 6C8.34986 6 8.69448 6.02246 9.03249 6.06601C10.4061 3.63845 13.0117 2 16 2C20.4183 2 24 5.58172 24 10ZM8.57223 7.02305C8.3835 7.00778 8.19266 7 8 7C4.13401 7 1 10.134 1 14C1 17.866 4.13401 21 8 21C10.4955 21 12.6861 19.6941 13.9255 17.7284C10.5129 16.8147 8 13.7008 8 10C8 8.94789 8.2031 7.94322 8.57223 7.02305Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairs);
export default __webpack_public_path__ + "static/media/Pairs.c9ac746b.svg";
export { ForwardRef as ReactComponent };